import { NavLink } from 'react-router-dom'
import {
  LayoutDashboard,
  Building2,
  Users,
  Settings,
  BarChart3,
  Shield,
  Bell
} from 'lucide-react'
import { cn } from '../../lib/utils'

type IconType = React.ComponentType<{ className?: string }>
type NavItem = { name: string; href: string; icon: IconType }

export const adminNavigation: NavItem[] = [
  { name: 'Dashboard', href: '/admin/dashboard', icon: LayoutDashboard },
  { name: 'Tenants', href: '/admin/tenants', icon: Building2 },
  { name: 'Users', href: '/admin/users', icon: Users },
  { name: 'Reports', href: '/admin/reports', icon: BarChart3 },
  { name: 'Announcements', href: '/admin/announcements', icon: Bell },
  { name: 'Settings', href: '/admin/settings', icon: Settings },
]

export function AdminSidebar() {
  return (
    <aside className="hidden md:flex md:flex-col w-72 bg-white/90 dark:bg-gray-900/90 backdrop-blur-xl border-r border-gray-200 dark:border-gray-800 shadow-soft min-h-[calc(100vh-73px)]">
      <div className="p-6 border-b border-gray-200 dark:border-gray-800">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-gradient-to-br from-orange-500 to-red-500 rounded-xl flex items-center justify-center shadow-soft">
            <Shield className="w-6 h-6 text-white" />
          </div>
          <div>
            <h2 className="text-base font-bold text-gray-900 dark:text-white">Admin Portal</h2>
            <p className="text-xs text-gray-500 dark:text-gray-400">Global Management</p>
          </div>
        </div>
      </div>

      <nav className="flex-1 px-4 py-6 space-y-1 custom-scrollbar overflow-y-auto">
        <div className="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider px-3 mb-3">
          Administration
        </div>
        {adminNavigation.map((item) => {
          const Icon = item.icon
          return (
            <NavLink
              key={item.name}
              to={item.href}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-3 px-3 py-2.5 text-sm font-medium rounded-xl transition-all duration-200 group',
                  isActive
                    ? 'bg-gradient-to-r from-orange-50 to-red-50 dark:from-orange-500/10 dark:to-red-500/10 text-orange-700 dark:text-orange-400 shadow-sm'
                    : 'text-gray-600 dark:text-gray-300 hover:bg-orange-50/50 dark:hover:bg-orange-500/5 hover:text-orange-700 dark:hover:text-orange-400'
                )
              }
            >
              {({ isActive }) => (
                <>
                  <Icon className={cn(
                    "h-5 w-5 transition-transform group-hover:scale-110",
                    isActive ? "text-orange-600 dark:text-orange-400" : ""
                  )} />
                  {item.name}
                  {isActive && (
                    <div className="ml-auto w-1.5 h-1.5 rounded-full bg-orange-500 animate-pulse" />
                  )}
                </>
              )}
            </NavLink>
          )
        })}
      </nav>
    </aside>
  )
}
